import './Cta.css';
function Cta() {
  return (
    <section className="cta">
      <div className="container">
        <h2>Transforme QA em vantagem operacional, não em etapa burocrática.</h2>
        <p>Uma estratégia bem montada reduz falhas, encurta ciclos de validação e aumenta a confiança em cada entrega.</p>
        <a className="btnLight" href="#contato">Solicitar proposta</a>
      </div>
    </section>
  );
}

export default Cta;
